import { useEffect, useState } from "react";
import { onIdTokenChanged } from "firebase/auth";
import { auth } from "../firebase";

export const useFirebaseAuthToken = () => {
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // This listener triggers on login, token refresh, and logout
    const unsubscribe = onIdTokenChanged(auth, async (user) => {
      if (user) {
        try {
          const idToken = await user.getIdToken(true);
          setToken(idToken);

          localStorage.setItem("idToken", idToken);
          localStorage.setItem("notifIdToken", idToken);
        } catch (err) {
          console.error("Error refreshing Firebase ID token:", err);
        }
      } else {
        setToken(null);
        localStorage.removeItem("idToken");
        localStorage.removeItem("notifIdToken");
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { token, loading };
};
